import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import userTypeEnum from "../../../constants/enums/user-type-enum";
import { useStore } from "../../../contexts/store-provider";
import {
  getStoreIdFromLocalStorage,
  getUserTypeFromLocalStorage
} from "../../../helpers/localstorage-helper";
import CustomerTopNavbar from "../../../shared-components/navbar/customer-top-navbar";
import AddEditProfile from "./components/add-edit-profile";
import "./profile.css";

const CustomerRegistration: React.FC = (props: any) => {
  const { preferencesStore, customerManagementStore } = useStore();
  const { GetCustomerByIdService } = customerManagementStore;
  const [language, setLanguage] = useState(preferencesStore.language);

  // when language changes
  useEffect(() => {
    const unsubscribe = () => {
      setLanguage(preferencesStore.language);
    };

    return () => unsubscribe();
  }, [preferencesStore.language]);

  const customerId = props.id ?? localStorage.getItem("lizera_userId");

  // useEffect(() => {
  //   if (customerId) {
  //     let userTypeFromLocalStorage = getUserTypeFromLocalStorage();
  //     GetCustomerByIdService(
  //       customerId,
  //       userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.SuperAdmin] &&
  //         userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.HeadQuarter]
  //         ? getStoreIdFromLocalStorage()
  //         : null
  //     );
  //   }
  // }, []);

  return (
    <>
      <CustomerTopNavbar />

      <ol className="breadcrumb ps-2 pt-3">
        <li className="breadcrumb-item">
          <svg
            className="me-1"
            fill="currentColor"
            version="1.1"
            id="fi_25694"
            x="0px"
            y="0px"
            width="15"
            height="15"
            viewBox="0 0 460.298 460.297"
          >
            <g>
              <g>
                <path
                  d="M230.149,120.939L65.986,256.274c0,0.191-0.048,0.472-0.144,0.855c-0.094,0.38-0.144,0.656-0.144,0.852v137.041
            c0,4.948,1.809,9.236,5.426,12.847c3.616,3.613,7.898,5.431,12.847,5.431h109.63V303.664h73.097v109.64h109.629
            c4.948,0,9.236-1.814,12.847-5.435c3.617-3.607,5.432-7.898,5.432-12.847V257.981c0-0.76-0.104-1.334-0.288-1.707L230.149,120.939
            z"
                ></path>
                <path
                  d="M457.122,225.438L394.6,173.476V56.989c0-2.663-0.856-4.853-2.574-6.567c-1.704-1.712-3.894-2.568-6.563-2.568h-54.816
            c-2.666,0-4.855,0.856-6.57,2.568c-1.711,1.714-2.566,3.905-2.566,6.567v55.673l-69.662-58.245
            c-6.084-4.949-13.318-7.423-21.694-7.423c-8.375,0-15.608,2.474-21.698,7.423L3.172,225.438c-1.903,1.52-2.946,3.566-3.14,6.136
            c-0.193,2.568,0.472,4.811,1.997,6.713l17.701,21.128c1.525,1.712,3.521,2.759,5.996,3.142c2.285,0.192,4.57-0.476,6.855-1.998
            L230.149,95.817l197.57,164.741c1.526,1.328,3.521,1.991,5.996,1.991h0.858c2.471-0.376,4.463-1.43,5.996-3.138l17.703-21.125
            c1.522-1.906,2.189-4.145,1.991-6.716C460.068,229.007,459.021,226.961,457.122,225.438z"
                ></path>
              </g>
            </g>
          </svg>
          <FormattedMessage id="Home" />
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          <FormattedMessage id="profile" />
        </li>
      </ol>
      <AddEditProfile key={language} />
    </>
  );
};

export default observer(CustomerRegistration);
